export default __webpack_public_path__ + "static/media/linkin-park.24fe3272.jpg";